import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  login(token: string) {
    localStorage.setItem('token', token);
    localStorage.setItem('loginTime', Date.now().toString());
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('token');
  }

  isSessionExpired(): boolean {
    const loginTime = Number(localStorage.getItem('loginTime'));
    const now = Date.now();
    const timeout = 60 * 60 * 1000; // 30 minutes in milliseconds
    return now - loginTime > timeout;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('loginTime');
  }
}
